/* FELVO theme — interactions: scroll reveal, header, AJAX cart, sort,
   product gallery, and an AJAX cart-count refresher. Vanilla, no deps.
   (The hero's parallax/story motion lives inline in sections/hero.liquid.) */
(function () {
  "use strict";

  /* ---- Scroll reveal (IntersectionObserver) ------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target;
            var delay = el.getAttribute("data-reveal-delay") || 0;
            el.style.animationDelay = delay + "ms";
            el.classList.add("is-in");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.18 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Cart count refresh (after AJAX add-to-cart elsewhere) ------------- */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
      })
      .catch(function () {});
  }

  /* ---- AJAX add-to-cart for product forms with data-ajax-cart ------------ */
  function initAjaxCart() {
    document.querySelectorAll('form[action$="/cart/add"][data-ajax-cart]').forEach(function (form) {
      if (form.__felvoAjax) return;
      form.__felvoAjax = true;
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) {
        // input[type=number] reports Arabic-Indic digits (e.g. ٢) as an empty value, and a blank required
        // field never fires submit. Fall back to 1 on blur, as the old AJAX serializer did.
        qty.addEventListener("blur", function () { if (!qty.value || parseInt(qty.value, 10) < 1) qty.value = "1"; });
      }
      form.addEventListener("submit", function (ev) {
        // 2026-09-13, ported from the US 09-08 funnel fix: the PDP form (opted in with data-native-submit in
        // sections/main-product.liquid) submits NATIVELY. Shopify POSTs /cart/add and lands the visitor on /cart
        // with a full-page Checkout button, and the product_added_to_cart pixel event fires on that page load
        // instead of racing a navigation. Quick-add cards and other product forms keep the AJAX behaviour below.
        if (form.hasAttribute("data-native-submit")) {
          // Double-submit guard (a second tap during a slow in-app page load used to POST /cart/add twice and
          // fire AddToCart twice) plus tap feedback. The button stays enabled for this tick so the browser still
          // submits, then is disabled; pageshow (bfcache back-navigation) resets it.
          if (form.__felvoSubmitting) { ev.preventDefault(); return; }
          form.__felvoSubmitting = true;
          var nb = form.querySelector('[type="submit"]');
          if (nb) {
            if (!nb.__felvoLabel) nb.__felvoLabel = nb.innerHTML;
            nb.innerHTML = nb.getAttribute("data-adding-label") || "Adding…";
            nb.setAttribute("aria-busy", "true");
            setTimeout(function () { nb.disabled = true; }, 0);
          }
          // On a phone the sticky bar is the button that was actually tapped, so it gets the same
          // "Adding…" label; the inline one is off-screen by then.
          var stickyBtn = document.querySelector("[data-sticky-atc-btn]");
          if (stickyBtn) {
            if (!stickyBtn.__felvoLabel) stickyBtn.__felvoLabel = stickyBtn.innerHTML;
            stickyBtn.innerHTML = (nb && nb.getAttribute("data-adding-label")) || stickyBtn.__felvoLabel;
            stickyBtn.setAttribute("aria-busy", "true");
            stickyBtn.disabled = true;
          }
          var reset = function () {
            form.__felvoSubmitting = false;
            if (nb) { nb.disabled = false; nb.removeAttribute("aria-busy"); if (nb.__felvoLabel) nb.innerHTML = nb.__felvoLabel; }
            if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.removeAttribute("aria-busy"); if (stickyBtn.__felvoLabel) stickyBtn.innerHTML = stickyBtn.__felvoLabel; }
          };
          // Watchdog: if the navigation never commits (POST stalls on bad mobile data, or the shopper cancels
          // it) the buttons must not stay dead until a manual reload.
          if (form.__felvoWatchdog) clearTimeout(form.__felvoWatchdog);
          form.__felvoWatchdog = setTimeout(reset, 8000);
          if (!form.__felvoPageshow) {
            form.__felvoPageshow = true;
            window.addEventListener("pageshow", function (e) {
              if (!e.persisted) return;
              if (form.__felvoWatchdog) clearTimeout(form.__felvoWatchdog);
              reset();
            });
          }
          return;
        }
        ev.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        /* Only the product page's own buy button declares data-added-label, and only it takes the
           persistent "Added, go to checkout" path. The collection-grid quick-add has no such label,
           so it keeps the old transient confirmation and can be tapped again to add another. */
        var addedLabel = btn ? btn.getAttribute("data-added-label") : null;
        if (addedLabel && form.__felvoAdded) { window.location.href = "/checkout"; return; }
        var orig = btn ? btn.innerHTML : "";
        if (btn) btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(serialize(form)),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            refreshCartCount();
            if (!addedLabel) {
              if (btn) {
                btn.innerHTML = "Added to cart ✓";
                setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1800);
              }
              return;
            }
            /* Add-to-cart used to be a dead end: the label reverted after 1.8 s with no path onward.
               Now the button stays as "Go to checkout", a View cart link appears, and the sticky bar
               pins itself and swaps to Checkout + View cart via the felvo:added event. */
            form.__felvoAdded = true;
            if (btn) {
              btn.innerHTML = addedLabel;
              btn.disabled = false;
            }
            var vc = form.querySelector("[data-view-cart-link]");
            if (vc) vc.hidden = false;
            try { document.dispatchEvent(new CustomEvent("felvo:added")); } catch (e) {}
          })
          .catch(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  function serialize(form) {
    var data = new FormData(form);
    var obj = { quantity: 1, properties: {} };
    data.forEach(function (v, k) {
      if (k === "id") obj.id = v;
      else if (k === "quantity") obj.quantity = parseInt(v, 10) || 1;
      else if (k.indexOf("properties[") === 0) {
        obj.properties[k.slice(11, -1)] = v;
      }
    });
    return obj;
  }

  /* ---- Header: frosted glass on scroll + mobile menu --------------------- */
  function initHeader() {
    var header = document.querySelector("[data-header]");
    if (header) {
      var onScroll = function () {
        header.classList.toggle("is-scrolled", window.scrollY > 24);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    var toggle = document.querySelector("[data-menu-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (toggle && menu) {
      var closeTimer = null;
      toggle.addEventListener("click", function () {
        var open = menu.hasAttribute("hidden");
        if (open) {
          // un-hide first, then flip [data-open] a frame later so the slide+fade transition runs
          clearTimeout(closeTimer);
          menu.removeAttribute("hidden");
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { menu.setAttribute("data-open", ""); });
          });
        } else {
          menu.removeAttribute("data-open");
          closeTimer = setTimeout(function () { menu.setAttribute("hidden", ""); }, 200);
        }
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
  }

  /* ---- Collection sorting: navigate to ?sort_by=<value> ------------------ */
  function initSort() {
    document.querySelectorAll("[data-sort-select]").forEach(function (sel) {
      if (sel.__felvoSort) return;
      sel.__felvoSort = true;
      sel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });
  }

  /* ---- Product gallery: scroll-snap carousel (RTL-safe, CSP-friendly) ----
     One track of w-full slides; arrows/thumbs/dots scroll to a slide via a
     getBoundingClientRect delta (sign-correct in both LTR and RTL), and a
     rAF-throttled scroll listener derives the active index for dots/thumbs.

     The reel is variant-scoped: `all*` hold every slide/thumb/dot the section
     rendered, while `slides`/`thumbs`/`dots` are the currently shown subset.
     applyFilter() rebuilds that subset for a variant (its own images first,
     then the shared ones) and reorders the DOM so index order stays visual
     order — which keeps every measurement below unchanged. */
  function initGallery() {
    var track = document.querySelector("[data-gallery-track]");
    if (!track || track.__felvoGallery) return;
    track.__felvoGallery = true;
    var allSlides = Array.prototype.slice.call(track.querySelectorAll("[data-gallery-slide]"));
    if (!allSlides.length) return;
    var root = track.closest("[data-gallery]") || document;
    var allThumbs = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-thumb]"));
    var allDots = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-dot]"));
    var thumbWrap = root.querySelector("[data-gallery-thumbs]");
    var dotWrap = root.querySelector("[data-gallery-dots]");
    var prev = root.querySelector("[data-gallery-prev]");
    var next = root.querySelector("[data-gallery-next]");
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var behavior = reduced ? "auto" : "smooth";
    var isRTL = getComputedStyle(track).direction === "rtl";
    var current = -1;
    var slides = allSlides.slice();
    var thumbs = allThumbs.slice();
    var dots = allDots.slice();

    function setActive(i) {
      if (i === current) return;
      current = i;
      dots.forEach(function (d, k) {
        if (k === i) { d.classList.add("bg-gold-300"); d.classList.remove("bg-cream/25"); }
        else { d.classList.add("bg-cream/25"); d.classList.remove("bg-gold-300"); }
      });
      thumbs.forEach(function (tb, k) {
        if (k === i) {
          tb.classList.add("ring-2", "ring-gold-300");
          tb.classList.remove("ring-1", "ring-white/10");
          /* Scroll only the thumbnail strip, never the window: scrollIntoView also scrolls the page, which dropped long-title product pages ~50px under the header on load (2026-10-17). */
          if (thumbWrap) {
            var wr = thumbWrap.getBoundingClientRect(), r = tb.getBoundingClientRect();
            var d = r.left < wr.left ? r.left - wr.left : (r.right > wr.right ? r.right - wr.right : 0);
            if (d) thumbWrap.scrollTo({ left: thumbWrap.scrollLeft + d, behavior: behavior });
          }
        } else {
          tb.classList.add("ring-1", "ring-white/10");
          tb.classList.remove("ring-2", "ring-gold-300");
        }
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i, bhv) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      var delta = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left: track.scrollLeft + delta, behavior: bhv || behavior });
      setActive(i);
    }

    /* Show only the given variant's images plus the unclaimed (shared) ones,
       the variant's own first. Called on every variant change; jumping is
       instant on purpose — the shopper asked for this view, so animating a
       scroll to it just reads as the page wandering off on its own. */
    function applyFilter(variantId) {
      var owned = [];
      var shared = [];
      allSlides.forEach(function (s, k) {
        var ids = s.getAttribute("data-variant-ids") || "-";
        if (variantId && ids.indexOf("," + variantId + ",") !== -1) owned.push(k);
        else if (ids === "-") shared.push(k);
      });
      var order = owned.concat(shared);
      if (!order.length) order = allSlides.map(function (_, k) { return k; });

      slides = [];
      thumbs = [];
      dots = [];
      allSlides.forEach(function (s) { s.hidden = true; });
      allThumbs.forEach(function (t) { t.hidden = true; });
      allDots.forEach(function (d) { d.hidden = true; });
      order.forEach(function (k) {
        allSlides[k].hidden = false;
        track.appendChild(allSlides[k]);
        slides.push(allSlides[k]);
        if (allThumbs[k] && thumbWrap) {
          allThumbs[k].hidden = false;
          thumbWrap.appendChild(allThumbs[k]);
          thumbs.push(allThumbs[k]);
        }
        if (allDots[k] && dotWrap) {
          allDots[k].hidden = false;
          dotWrap.appendChild(allDots[k]);
          dots.push(allDots[k]);
        }
      });

      var single = slides.length < 2;
      if (prev) prev.hidden = single;
      if (next) next.hidden = single;
      if (dotWrap) dotWrap.hidden = single;
      if (thumbWrap) thumbWrap.hidden = single;
      current = -1;
      goTo(0, "auto");
    }

    var raf = null;
    track.addEventListener(
      "scroll",
      function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          var i = Math.round(Math.abs(track.scrollLeft) / w);
          setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      },
      { passive: true }
    );

    if (prev) prev.addEventListener("click", function () { goTo(current - 1); });
    if (next) next.addEventListener("click", function () { goTo(current + 1); });
    /* Bind against the live subset, not the render-time index — filtering
       reorders and hides these, so a captured index would go stale. */
    allThumbs.forEach(function (tb) { tb.addEventListener("click", function () { goTo(thumbs.indexOf(tb)); }); });
    allDots.forEach(function (d) { d.addEventListener("click", function () { goTo(dots.indexOf(d)); }); });

    track.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var forward = (e.key === "ArrowRight") !== isRTL;
      goTo(current + (forward ? 1 : -1));
    });

    track.__felvoGoTo = goTo;
    track.__felvoFilter = applyFilter;
    setActive(0);
  }

  /* ---- Variant select: live-update price + scope gallery on change -------
     The buy box renders the default variant server-side; this reflects the
     chosen variant's price/compare-at and narrows the gallery to that
     variant's own images plus the shared lifestyle shots. */
  function initVariantSelect() {
    var sel = document.querySelector('select[name="id"]');
    if (!sel || sel.__felvoVariant) return;
    sel.__felvoVariant = true;
    var priceEl = document.querySelector("[data-price-display]");
    var compareEl = document.querySelector("[data-compare-display]");
    var track = document.querySelector("[data-gallery-track]");
    /* The sticky bar's thumb was rendered from product.featured_image while the gallery is
       variant-scoped, so the bar could show a different colourway from the one on screen. Swap it to
       the selected variant's own image, falling back to the featured image for variants that carry
       none (shared lifestyle shots). */
    var stickyImg = document.querySelector("[data-sticky-img]");
    var stickyImgDefault = stickyImg ? stickyImg.getAttribute("src") : null;
    function update() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare) { compareEl.textContent = opt.dataset.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (stickyImg) {
        var nextSrc = opt.dataset.img || stickyImgDefault;
        if (nextSrc && stickyImg.getAttribute("src") !== nextSrc) stickyImg.src = nextSrc;
      }
      if (track && track.__felvoFilter) track.__felvoFilter(opt.value);
      var btn = sel.form ? sel.form.querySelector('button[type="submit"]') : null;
      if (btn && !(sel.form && (sel.form.__felvoAdded || sel.form.__felvoSubmitting))) {
        if (!btn.__felvoLabel) btn.__felvoLabel = btn.innerHTML;
        if (opt.disabled) { btn.disabled = true; btn.innerHTML = btn.getAttribute("data-soldout-label") || "Sold out"; }
        else { btn.disabled = false; btn.innerHTML = btn.__felvoLabel; }
      }
      // Ported 2026-09-13 (US refuter finding 09-08): mirror the sold-out state onto the sticky mobile bar,
      // which used to stay tappable and, with the native submit, would POST an unavailable variant.
      var sticky = document.querySelector("[data-sticky-atc-btn]");
      if (sticky && !(sel.form && sel.form.__felvoSubmitting)) {
        if (!sticky.__felvoLabel) sticky.__felvoLabel = sticky.innerHTML;
        sticky.disabled = !!opt.disabled;
        sticky.innerHTML = opt.disabled ? ((btn && btn.getAttribute("data-soldout-label")) || "Sold out") : sticky.__felvoLabel;
      }
    }
    sel.addEventListener("change", update);
    update();
  }

  /* ---- Variant tiles: progressive enhancement over the select ------------
     Tiles set sel.value and dispatch change, so price/compare/gallery scoping
     in initVariantSelect fire untouched and the form still posts name="id".
     Only once tiles are wired do we hide the dropdown wrapper — no JS, no
     tiles, dropdown keeps working. */

  /* ---- Per-option variant selector (owner request 2026-09-02) -------------
     One group per option. Resolves the chosen combination to a variant, sets
     the hidden select and dispatches change, so initVariantSelect keeps doing
     price, gallery scoping and the sticky thumb. Values that lead to no
     variant are dimmed (data-na); values whose variants are all sold out are
     struck through (data-soldout) but stay selectable so the button can say
     Sold out. Clicking a value that does not combine with the current
     selection keeps that value and frees the other options. */
  function initVariantOptions() {
    var sel = document.querySelector('select[name="id"]');
    var wrap = document.querySelector("[data-voptions]");
    if (!sel || !wrap || wrap.__felvoOpts) return;
    wrap.__felvoOpts = true;
    var variants;
    try { variants = JSON.parse(wrap.getAttribute("data-variants")); } catch (e) { return; }
    var groups = Array.prototype.slice.call(wrap.querySelectorAll("[data-voption]"));
    var state = groups.map(function (g) {
      var p = g.querySelector('[data-vvalue][aria-pressed="true"]');
      return p ? p.getAttribute("data-value") : null;
    });
    function find(st) {
      return variants.filter(function (v) {
        return v.o.every(function (x, i) { return st[i] === null || x === st[i]; });
      });
    }
    function paint() {
      groups.forEach(function (g, i) {
        var cur = g.querySelector("[data-vopt-current]");
        if (cur) cur.textContent = state[i] || "";
        g.querySelectorAll("[data-vvalue]").forEach(function (b) {
          var val = b.getAttribute("data-value");
          b.setAttribute("aria-pressed", String(val === state[i]));
          var st = state.slice(); st[i] = val;
          var m = find(st);
          b.setAttribute("data-na", String(m.length === 0));
          b.setAttribute("data-soldout", String(m.length > 0 && !m.some(function (v) { return v.a; })));
        });
      });
    }
    function commit() {
      var m = find(state);
      if (!m.length) return;
      var v = m.filter(function (x) { return x.a; })[0] || m[0];
      state = v.o.slice();
      if (String(sel.value) !== String(v.id)) {
        sel.value = String(v.id);
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
      paint();
    }
    groups.forEach(function (g, i) {
      g.querySelectorAll("[data-vvalue]").forEach(function (b) {
        b.addEventListener("click", function () {
          var val = b.getAttribute("data-value");
          var st = state.slice(); st[i] = val;
          if (!find(st).length) st = state.map(function (x, j) { return j === i ? val : null; });
          state = st;
          commit();
        });
      });
    });
    var selWrap = document.querySelector("[data-variant-select-wrap]");
    if (selWrap) selWrap.hidden = true;
    var tiles = document.querySelector("[data-vtiles]");
    if (tiles) tiles.hidden = true;
    wrap.hidden = false;
    commit();
  }

  function initVariantTiles() {
    var sel = document.querySelector('select[name="id"]');
    var wrap = document.querySelector("[data-vtiles]");
    if (!sel || !wrap || wrap.__felvoTiles) return;
    if (document.querySelector("[data-voptions]")) return; // multi-option products use initVariantOptions
    wrap.__felvoTiles = true;
    var tiles = wrap.querySelectorAll("[data-vtile]");
    if (!tiles.length) return;
    function sync() {
      tiles.forEach(function (b) {
        b.setAttribute("aria-pressed", String(b.getAttribute("data-variant-id") === sel.value));
      });
    }
    tiles.forEach(function (b) {
      b.addEventListener("click", function () {
        /* Sold-out tiles now use aria-disabled so they stay focusable and announced; the click guard
           has to read that attribute as well as the (legacy) native disabled state. */
        if (b.disabled || b.getAttribute("aria-disabled") === "true") return;
        sel.value = b.getAttribute("data-variant-id");
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        sync();
      });
    });
    var selWrap = document.querySelector("[data-variant-select-wrap]");
    if (selWrap) selWrap.hidden = true;
    wrap.hidden = false;
    sync();
  }

  /* ---- Sticky mobile add-to-cart -----------------------------------------
     Reveals the fixed bar when the product form (inline buy button) leaves
     the viewport; the bar's button requestSubmit()s the SAME form, so the
     ajax cart, properties and pixel events are identical to an inline add. */
  function initStickyAtc() {
    var bar = document.querySelector("[data-sticky-atc]");
    var form = document.querySelector('form[action$="/cart/add"][data-ajax-cart]');
    if (!bar || !form || bar.__felvoSticky) return;
    bar.__felvoSticky = true;
    if (!("IntersectionObserver" in window)) return;
    var btn = bar.querySelector("[data-sticky-atc-btn]");
    if (btn)
      btn.addEventListener("click", function () {
        // Ported 2026-09-13: never submit a sold-out variant (the inline button is the source of truth for
        // availability) and never submit twice while a native submit is in flight.
        var inline = form.querySelector('button[type="submit"]');
        if (btn.disabled || form.__felvoSubmitting || (inline && inline.disabled)) return;
        var q = form.querySelector('input[name="quantity"]');
        if (q && (!q.value || parseInt(q.value, 10) < 1)) q.value = "1";
        // requestSubmit fires the submit event and runs validation; on engines without it, clicking the
        // inline button does the same, whereas form.submit() would skip the guard and the pixel path.
        if (form.requestSubmit) form.requestSubmit();
        else if (inline) inline.click();
        else form.submit();
      });
    var priceEl = document.querySelector("[data-price-display]");
    var sp = bar.querySelector("[data-sticky-price]");
    var mp = document.querySelector("[data-mintro-price]"); // mobile intro price above the gallery
    if (priceEl && (sp || mp)) {
      var syncPrice = function () {
        if (sp) sp.textContent = priceEl.textContent;
        if (mp) mp.textContent = priceEl.textContent;
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    var io = new IntersectionObserver(function (entries) {
      bar.hidden = bar.__felvoLock ? false : entries[0].isIntersecting;
    }, { rootMargin: "0px 0px -8% 0px" });
    io.observe(form);
    // After an add, pin the bar and swap Add-to-cart for Checkout + View cart.
    document.addEventListener("felvo:added", function () {
      bar.__felvoLock = true;
      bar.hidden = false;
      if (btn) btn.hidden = true;
      bar.querySelectorAll("[data-sticky-after]").forEach(function (el) { el.hidden = false; });
    });
  }

  /* ---- Money formatting (Shopify money_format placeholders) -------------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = parseInt(cents.replace(".", ""), 10);
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ","; decimal = decimal || ".";
      if (isNaN(number) || number == null) return "0";
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var m = (format || "{{amount}}").match(placeholder);
    var key = m ? m[1] : "amount";
    var value;
    if (key === "amount_no_decimals") value = withDelimiters(cents, 0);
    else if (key === "amount_with_comma_separator") value = withDelimiters(cents, 2, ".", ",");
    else if (key === "amount_no_decimals_with_comma_separator") value = withDelimiters(cents, 0, ".", ",");
    else value = withDelimiters(cents, 2);
    return (format || "{{amount}}").replace(placeholder, value);
  }

  /* ---- Cart page: live line-total + subtotal on qty change / remove ------
     Enhances the standard POST-and-reload cart form with /cart/change.js so
     prices update instantly; falls back to the Update button if JS fails. */
  function initCartPage() {
    var form = document.querySelector("[data-cart-form]");
    if (!form || form.__felvoCart) return;
    form.__felvoCart = true;
    // With the live quantity path wired, Update is redundant and competes with Checkout.
    // CSS in templates/cart.liquid hides it under .felvo-cart-live. It is never disabled and
    // never removed: it must stay the form's first, enabled submit button so that implicit
    // submission (Enter, or the iOS numeric keypad's Go key) can never reach Checkout.
    form.classList.add("felvo-cart-live");
    var moneyFormat = form.getAttribute("data-money-format") || "{{amount}}";
    function render(cart) {
      if (!cart || cart.item_count === 0) { window.location.reload(); return; }
      var byKey = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; });
      form.querySelectorAll("[data-cart-line]").forEach(function (row) {
        var item = byKey[row.getAttribute("data-key")];
        // Line keys change when a cart-level discount re-allocates; a full reload keeps the row visible.
        if (!item) { if (cart.item_count > 0) { window.location.reload(); } else { row.remove(); } return; }
        var lp = row.querySelector("[data-line-price]");
        /* Rebuild the cell's HTML, not just its text: a discounted line renders a compare-at <s> in
           templates/cart.liquid and textContent would wipe it (and its RTL-aware pe-2) on the first
           quantity change. Keep the class string byte-identical to the one in templates/cart.liquid.
           formatMoney only ever emits digits plus the fixed currency wording, so there is nothing to
           escape here. */
        if (lp) {
          var was = "";
          if (item.original_line_price > item.final_line_price) {
            was = '<s class="pe-2 font-normal text-cream-muted/55">' +
              formatMoney(item.original_line_price, moneyFormat) + "</s>";
          }
          lp.innerHTML = was + formatMoney(item.final_line_price, moneyFormat);
        }
        var qi = row.querySelector("[data-qty]");
        if (qi) {
          // defaultValue is what a blanked field falls back to (see the change handler below), so it
          // must follow the live quantity rather than the server-rendered one.
          qi.defaultValue = item.quantity;
          if (document.activeElement !== qi) qi.value = item.quantity;
        }
      });
      var sub = document.querySelector("[data-cart-subtotal]");
      if (sub) sub.textContent = formatMoney(cart.items_subtotal_price, moneyFormat);

      // UAE port 2026-09-02 (US audit F-F04 / C-MM-05): discount rows stay in sync.
      var disc = document.querySelector("[data-cart-discounts]");
      if (disc) {
        var apps = cart.cart_level_discount_applications || [];
        disc.innerHTML = apps.map(function (a) {
          return '<div class="flex items-baseline justify-between gap-3 text-gold-300"><span class="truncate">' +
            (a.title || "") + '</span><span class="felvo-cart-num shrink-0">&minus;' +
            formatMoney(parseInt(a.total_allocated_amount || 0, 10), moneyFormat) + "</span></div>";
        }).join("");
        disc.hidden = apps.length === 0;
      }

      /* 2026-09-13: on this store shipping is a FACT, not an unknown, so the cart prints it and has to
         keep printing the right one after a quantity change. The threshold (24900 fils) and the flat
         rate (3500 fils) are declared once in templates/cart.liquid and arrive here as data attributes;
         the literals below are only a fallback if the markup ever loses them. There is exactly ONE
         [data-cart-shipping] node, so the colour toggle cannot drift from what Liquid painted. */
      var ship = document.querySelector("[data-cart-shipping]");
      var shipThreshold = ship ? parseInt(ship.getAttribute("data-threshold") || "24900", 10) : 24900;
      var shipFee = ship ? parseInt(ship.getAttribute("data-fee") || "3500", 10) : 3500;
      var shipCost = cart.total_price >= shipThreshold ? 0 : shipFee;
      if (ship) {
        ship.textContent = shipCost === 0 ? (ship.getAttribute("data-free-label") || "Free")
                                          : formatMoney(shipCost, moneyFormat);
        ship.classList.toggle("font-bold", shipCost === 0);
        ship.classList.toggle("text-gold-300", shipCost === 0);
        ship.classList.toggle("text-cream-bright", shipCost !== 0);
      }

      /* Total means the amount charged: cart after discounts, plus the shipping rate.
         querySelectorAll, not querySelector: the summary ledger and the pinned bar both print it. */
      Array.prototype.forEach.call(document.querySelectorAll("[data-cart-total]"), function (el) {
        el.textContent = formatMoney(cart.total_price + shipCost, moneyFormat);
      });

      /* The free-shipping nudge only exists while there is something to nudge about. At or above the
         threshold the Shipping row already says Free and a second gold line is noise. */
      var fs = document.querySelector("[data-free-ship]");
      if (fs) {
        var remaining = shipThreshold - cart.total_price;
        if (remaining > 0) {
          fs.hidden = false;
          fs.textContent = (fs.getAttribute("data-remaining") || "").replace("__AMOUNT__", formatMoney(remaining, moneyFormat));
        } else {
          fs.hidden = true;
          fs.textContent = "";
        }
      }

      refreshCartCount();
    }
    function change(key, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(render).catch(function () { window.location.reload(); });
    }
    form.querySelectorAll("[data-qty]").forEach(function (inp) {
      inp.addEventListener("change", function () {
        // 2026-09-13: an emptied or non-numeric field is "no change", not "remove". Update is hidden
        // when JS is live and Checkout sits right under the field, so blurring an empty field into
        // Checkout must never silently delete the line. An explicit 0 still removes.
        var raw = (inp.value || "").trim();
        var q = parseInt(raw, 10);
        if (raw === "" || isNaN(q)) { inp.value = inp.defaultValue; return; }
        if (q < 0) q = 0;
        change(inp.getAttribute("data-key"), q);
      });
    });
    form.querySelectorAll("[data-remove]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        change(a.getAttribute("data-key"), 0);
      });
    });
  }

  /* ---- Welcome popup: first-order WELCOME10 email capture + reveal --------
     Native <dialog> (rendered globally in layout/theme.liquid). Opens on the
     first of {6s timer, 35% scroll, desktop exit-intent}; a 30-day localStorage
     cap suppresses dismissals and "converted" hides it forever. Email is a
     best-effort background POST to Shopify's customer form (never blocks the
     reveal), then the code panel is shown. GA4 events fire when gtag exists. */
  function initWelcomePopup() {
    var dialog = document.querySelector("[data-welcome-popup]");
    if (!dialog || dialog.__felvoWP) return;
    dialog.__felvoWP = true;

    var KEY = "felvo_welcome_v1";
    var SUPPRESS_MS = 30 * 24 * 60 * 60 * 1000;

    function read() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function write(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

    var state = read();
    if (state === "converted") return;
    if (state && state.indexOf("dismissed:") === 0) {
      var ts = parseInt(state.slice(10), 10);
      if (!isNaN(ts) && Date.now() - ts < SUPPRESS_MS) return;
    }

    var form = dialog.querySelector("[data-wp-form]");
    var emailInput = dialog.querySelector("[data-wp-email]");
    var consent = dialog.querySelector("[data-wp-consent]");
    var errorEl = dialog.querySelector("[data-wp-error]");
    var capturePanel = dialog.querySelector('[data-wp-panel="capture"]');
    var revealPanel = dialog.querySelector('[data-wp-panel="reveal"]');
    var copyBtn = dialog.querySelector("[data-wp-copy]");
    var codeText = dialog.querySelector("[data-wp-code-text]");
    var opened = false;

    function track(name) { if (window.gtag) { try { window.gtag("event", name); } catch (e) {} } }

    var timer = null;
    function teardown() {
      if (timer) clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onExit);
    }
    function open() {
      if (opened) return;
      opened = true;
      teardown();
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
      track("welcome_popup_view");
    }
    function close() {
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
    }
    function dismiss() { write("dismissed:" + Date.now()); close(); }

    function onScroll() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      if (h.scrollTop / max > 0.35) open();
    }
    function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) open(); }

    timer = setTimeout(open, 6000);
    window.addEventListener("scroll", onScroll, { passive: true });
    if (!("ontouchstart" in window)) document.addEventListener("mouseout", onExit);

    dialog.querySelectorAll("[data-wp-close]").forEach(function (b) {
      b.addEventListener("click", dismiss);
    });
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dismiss(); });
    dialog.addEventListener("cancel", function () { write("dismissed:" + Date.now()); });

    function reveal() {
      if (capturePanel) capturePanel.hidden = true;
      if (revealPanel) { revealPanel.hidden = false; revealPanel.classList.add("pp-in"); }
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = emailInput ? emailInput.value.trim() : "";
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          if (errorEl) errorEl.hidden = false;
          if (emailInput) emailInput.focus();
          return;
        }
        if (errorEl) errorEl.hidden = true;
        // Best-effort Shopify customer capture — marketing tag only if consented.
        try {
          var body = new URLSearchParams();
          body.append("form_type", "customer");
          body.append("utf8", "✓");
          body.append("contact[email]", email);
          body.append("contact[tags]", consent && consent.checked ? "newsletter, welcome-popup" : "welcome-popup");
          fetch("/contact", { method: "POST", body: body, headers: { Accept: "text/html" } }).catch(function () {});
        } catch (err) {}
        write("converted");
        track("welcome_signup");
        reveal();
      });
    }

    if (copyBtn && codeText) {
      copyBtn.addEventListener("click", function () {
        var code = codeText.textContent.trim();
        var orig = copyBtn.textContent;
        var done = function () {
          copyBtn.textContent = copyBtn.getAttribute("data-copied-label") || "Copied";
          setTimeout(function () { copyBtn.textContent = orig; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else { done(); }
      });
    }
  }

  /* ---- The Companion: scroll cat + ball-as-progress ---------------------
     Mirrored 1:1 with src/components/ScrollCat.jsx on the reference site —
     keep both in sync. Spec: docs/specs/2026-07-19-scroll-cat.md.
     Velocity comes from a rolling window of scroll-event samples (never rAF
     dt — it false-pounces under frame throttling). The rAF loop sleeps when
     the cat loafs and everything is settled. */
  function initScrollCat() {
    var rail = document.getElementById("fl-companion");
    if (!rail || rail.dataset.flInit) return;
    rail.dataset.flInit = "1";
    var trail = document.getElementById("fl-trail");
    var ballEl = document.getElementById("fl-ball");
    var ballRot = document.getElementById("fl-ball-rot");
    var catEl = document.getElementById("fl-cat");
    var imgs = {};
    rail.querySelectorAll(".fl-pose").forEach(function (n) { imgs[n.dataset.pose] = n; });
    /* iOS insurance: position:fixed breaks under any transformed/filtered
       ancestor (Safari-only trigger set) — keep the rail a direct body child */
    if (rail.parentElement !== document.body) document.body.appendChild(rail);
    /* read scroll from scrollingElement so body-scroller modes still work */
    var scroller = document.scrollingElement || document.documentElement;

    var T = {
      followStiff: 90, followDamp: 16, squashStiff: 260, squashDamp: 14,
      wobbleStiff: 200, wobbleDamp: 9, energyRise: 0.16, energyFall: 0.045,
      hopAmp: 6, hopFreq: 0.05, pounceVel: 3.2, pounceMinDist: 90,
      restDelay: 1800, loafDelay: 12000, edgePad: 26, catBallGap: 28
    };
    var S = {
      progress: 0, scrollV: 0, lastT: performance.now(),
      energy: 0, lastScrollAt: performance.now(),
      catX: T.edgePad + 60, catVX: 0, dir: 1,
      squash: 1, squashV: 0, wobble: 0, wobbleV: 0,
      hopPhase: 0, bob: 0, tilt: 0,
      mode: "rest", modeAt: 0, pounceUntil: 0, batUntil: 0,
      turnUntil: 0, stretchUntil: 0, launched: false, wasFast: false,
      wiggleX: 0, stretchX: 1, stretchY: 1, breathing: false,
      faceV: 0, lastFlipAt: 0, tgtBall: -1, lastBx: -1, bd: 0, bdAt: -1e9, side: 0,
      rtl: document.documentElement.dir === "rtl",
      tone: "espresso",
      /* Reduced motion: run a calm mode instead of hiding the whole rail (the
         old CSS display:none made the cat look broken on any Mac with "Reduce
         motion" on). Re-read live so an OS toggle takes effect without reload. */
      reduced: !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
    };
    if (window.matchMedia) {
      var rmq = window.matchMedia("(prefers-reduced-motion: reduce)");
      var onRm = function () { S.reduced = rmq.matches; wake(); };
      if (rmq.addEventListener) rmq.addEventListener("change", onRm);
      else if (rmq.addListener) rmq.addListener(onRm);
    }
    /* RTL reads start at the RIGHT edge — boot the cat beside the ball's
       start, not across the screen from it */
    if (S.rtl) S.catX = Math.max(40, rail.clientWidth - T.edgePad - 60);

    function trackW() { return rail.clientWidth - T.edgePad * 2; }
    function ballX() {
      var x = T.edgePad + S.progress * trackW();
      return S.rtl ? rail.clientWidth - x : x;
    }
    function spring(x, v, target, k, c, dt) {
      v += ((target - x) * k - v * c) * dt;
      return [x + v * dt, v];
    }
    function setPose(name) {
      for (var p in imgs) imgs[p].style.display = p === name ? "block" : "none";
    }

    var samples = [];
    function onScroll() {
      var t = performance.now();
      var y = scroller.scrollTop;
      var last = samples[samples.length - 1];
      if (last && t - last[0] < 8 && last[1] === y) return; /* window+document dupe */
      samples.push([t, y]);
      while (samples.length > 2 && t - samples[0][0] > 130) samples.shift();
      S.lastScrollAt = t;
      wake();
    }
    function windowedV() {
      if (samples.length < 2) return 0;
      var a = samples[0], b = samples[samples.length - 1];
      var dt = (b[0] - a[0]) / 1000;
      return dt > 0.016 ? (b[1] - a[1]) / dt : 0;
    }

    var toneTick = 0;
    function toneCheck(now) {
      if (now - toneTick < 300) return;
      toneTick = now;
      var el = document.elementFromPoint(
        Math.max(8, Math.min(rail.clientWidth - 8, S.catX)),
        window.innerHeight - 40
      );
      /* Walk for a real background-color, stopping BEFORE body (body's dark
         base lies under transparent light sections). If none resolves, use
         the point's TEXT color as proxy: light text = dark section. */
      var want = null, n = el;
      while (n && n !== document.body && n !== document.documentElement) {
        var bg = getComputedStyle(n).backgroundColor || "";
        var m = bg.match(/\d+(\.\d+)?/g);
        if (m && m.length >= 3 && (m.length < 4 || parseFloat(m[3]) > 0.5)) {
          want = 0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2] < 128 ? "cream" : "espresso";
          break;
        }
        n = n.parentNode;
      }
      if (!want && el) {
        var c = (getComputedStyle(el).color || "").match(/\d+(\.\d+)?/g);
        if (c && c.length >= 3) {
          want = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2] > 128 ? "cream" : "espresso";
        }
      }
      if (!want) want = "espresso";
      if (want !== S.tone) {
        S.tone = want;
        for (var p in imgs) imgs[p].setAttribute("href", imgs[p].dataset[want]);
      }
    }

    function think(now, dt) {
      var bx = ballX();
      var idle = now - S.lastScrollAt;

      /* Calm mode (prefers-reduced-motion): the cat sits beside its progress
         ball and tracks it 1:1 with scroll, like a scrollbar thumb — no
         autonomous motion (gallop, pounce, hop, wobble, breathing). Snapping
         (no spring) means it moves only while scrolling and never overshoots. */
      if (S.reduced) {
        S.tgtBall = bx;
        var calmSide = S.rtl ? -1 : 1;          /* trail on the reading-start side */
        S.catX = bx - calmSide * 32;
        S.dir = S.catX <= bx ? 1 : -1;          /* face the ball */
        S.bob = 0; S.tilt = 0; S.squash = 1; S.wobble = 0;
        S.wiggleX = 0; S.stretchX = 1; S.stretchY = 1;
        setPose("sit");
        if (S.breathing) { S.breathing = false; catEl.classList.remove("fl-breathe"); }
        return;
      }
      var vNorm = Math.min(Math.abs(S.scrollV) / window.innerHeight, 4);
      var rate = vNorm > S.energy ? T.energyRise : T.energyFall;
      S.energy += (vNorm - S.energy) * Math.min(1, rate * dt * 60);

      if (vNorm > T.pounceVel && Math.abs(bx - S.catX) > T.pounceMinDist && now > S.pounceUntil) {
        S.mode = "pounce"; S.modeAt = now; S.pounceUntil = now + 570;
        S.launched = false;
        S.squashV -= 5;                       /* anticipation dip */
      }
      if (S.mode === "pounce" && now >= S.pounceUntil) {
        S.mode = "chase"; S.batUntil = now + 240; S.wobbleV += 260;
      }
      if (S.mode !== "pounce") {
        if (idle < 140) {
          if (S.mode === "loaf") S.stretchUntil = now + 260;   /* wake-up stretch */
          S.mode = "chase";
        } else if (idle < T.restDelay) {
          if (S.mode === "chase" && S.wasFast) {               /* caught it: joy bounce + bat */
            S.batUntil = now + 220; S.squashV -= 3.5; S.wasFast = false;
          }
          S.mode = "alert";
        } else if (idle < T.loafDelay) S.mode = "rest";
        else S.mode = "loaf";
      }

      /* Chase target gate: a cat doesn't chase jittering prey — it freezes
         and watches. The target only re-locks when the ball's direction has
         been stable ~350ms, or the move is decisively large (instant flick
         response); sub-30px wobble is ignored entirely. */
      if (S.lastBx < 0) S.lastBx = bx;
      var bd = bx > S.lastBx + 2 ? 1 : bx < S.lastBx - 2 ? -1 : S.bd;
      if (bd !== S.bd) { S.bd = bd; S.bdAt = now; }
      S.lastBx = bx;
      if (S.tgtBall < 0) S.tgtBall = bx;
      if ((now - S.bdAt > 350 || Math.abs(bx - S.tgtBall) > 140) && Math.abs(bx - S.tgtBall) > 30) S.tgtBall = bx;
      /* Once the scroll has STOPPED, the stickiness (jitter armor) must not
         leave a standoff — walk the last stretch and put the nose on the
         ball, so a finished page reads finished. */
      if (idle > 250 && Math.abs(bx - S.tgtBall) > 2) S.tgtBall = bx;
      /* Side hysteresis (v4.4): which side of the ball the cat trails on is
         STATE, not a per-frame read of facing. Facing follows velocity, so
         deriving the target side from facing let the two feed each other:
         with the ball directly under the cat, every step flipped facing,
         facing flipped the target to the ball's other side, and the cat
         vibrated in both directions. (v4.3's rest latch only froze this
         after scroll events stopped; slow scrolls and micro-scroll wiggles
         still oscillated.) The side re-evaluates only when the cat is
         CLEARLY past the gated ball (8px) and holds through the dead zone,
         so a ball parked under the cat resolves to one calm sidestep. */
      if (S.catX < S.tgtBall - 8) S.side = 1;
      else if (S.catX > S.tgtBall + 8) S.side = -1;
      else if (!S.side) S.side = S.rtl ? -1 : 1;
      /* Parked distance is measured center-to-center: sprites extend up to
         ~22px ahead of center (loaf widest), so 32 puts the ball just clear
         of the nose in every pose, close but visibly a ball. */
      var gapWanted = idle > 250 ? 32 : T.catBallGap;
      var target = S.tgtBall - S.side * gapWanted;
      /* Distance-adaptive spring: nonchalant up close, sprints when far
         behind (fast scrolls) — constant softness read as broken lag. */
      var gapNow = Math.abs(target - S.catX);
      var kAdapt = T.followStiff * (1 + Math.min(3, gapNow / 180));
      var cAdapt = T.followDamp * (1 + Math.min(1.2, gapNow / 400));
      var r = spring(S.catX, S.catVX, target, kAdapt, cAdapt, dt);
      S.catX = r[0]; S.catVX = r[1];
      /* Facing: follow SMOOTHED velocity — raw spring velocity oscillates
         through zero while tracking, and raw-sign facing mirror-flickers.
         EMA (tau ~170ms) + a 250ms flip cooldown; face the target's side
         only when effectively parked. Never moonwalks, never vibrates.
         (Flip-count simulated: 0 flips on stop-start/settle/jitter, exactly
         1 per real reversal, instant flick response.) */
      S.faceV += (S.catVX - S.faceV) * Math.min(1, 6 * dt);
      var nd = S.dir;
      if (idle > 250) {
        nd = S.side;                     /* parked: face the ball from the held side, no velocity flips */
      } else if (Math.abs(S.faceV) > 60) {
        nd = S.faceV > 0 ? 1 : -1;
      } else if (Math.abs(S.catVX) < 40) {
        nd = S.side;                     /* settled mid-scroll: face the ball from the held side */
      }
      if (nd !== S.dir && now - S.lastFlipAt > 250) {
        S.dir = nd;
        S.lastFlipAt = now;
        if (S.mode === "chase") S.turnUntil = now + 170; /* double-take */
      }

      var speed = Math.abs(S.catVX);
      if (speed > 250) S.wasFast = true;
      if (speed > 30 && (S.mode === "chase" || S.mode === "pounce")) {
        var prev = S.hopPhase;
        /* stride-rate cap: fast cats lengthen stride, they don't strobe —
           uncapped phase alternated poses every ~2 frames at sprint speed */
        S.hopPhase += Math.min(speed, 620) * dt * T.hopFreq;
        S.bob = -Math.abs(Math.sin(S.hopPhase)) * T.hopAmp * Math.min(1, speed / 420);
        if (Math.floor(prev / Math.PI) !== Math.floor(S.hopPhase / Math.PI)) S.squashV -= 2.2;
      } else S.bob *= 0.86;
      S.tilt = Math.max(-4.5, Math.min(4.5, S.catVX * 0.009)) * S.dir;

      /* pose + expression channels (chosen after locomotion so the gait
         reacts to real speed, not to scroll energy) */
      S.wiggleX = 0; S.stretchX = 1; S.stretchY = 1;
      if (S.mode === "pounce") {
        if (now - S.modeAt < 240) {
          setPose("crouch");                  /* wind-up: butt wiggle */
          S.wiggleX = Math.sin(now * 0.115) * 0.045;
        } else {
          if (!S.launched) { S.launched = true; S.catVX += (bx > S.catX ? 1 : -1) * 900; }
          setPose("leap");
        }
      } else if (now < S.batUntil) setPose("bat");
      else if (now < S.stretchUntil) { setPose("crouch"); S.stretchX = 1.13; S.stretchY = 0.94; }
      else if (now < S.turnUntil) setPose("alert");
      else if (S.mode === "chase") {
        /* 2-sprite gallop: gathered/extended alternating on the hop phase */
        if (speed > 70) setPose(Math.floor(S.hopPhase / Math.PI) % 2 ? "leap" : "crouch");
        else setPose("alert");
      } else if (S.mode === "alert") setPose("alert");
      else if (S.mode === "rest") setPose("sit");
      else setPose("loaf");

      /* idle breathing is CSS-driven so it survives the rAF sleep */
      var breathe = S.mode === "rest" || S.mode === "loaf";
      if (breathe !== S.breathing) { S.breathing = breathe; catEl.classList.toggle("fl-breathe", breathe); }

      r = spring(S.squash, S.squashV, 1, T.squashStiff, T.squashDamp, dt);
      S.squash = Math.max(0.85, Math.min(1.12, r[0])); S.squashV = r[1];
      r = spring(S.wobble, S.wobbleV, 0, T.wobbleStiff, T.wobbleDamp, dt);
      S.wobble = r[0]; S.wobbleV = r[1];
    }

    function render() {
      var bx = ballX();
      if (S.rtl) {
        trail.style.left = bx + "px";
        trail.style.width = (rail.clientWidth - T.edgePad - bx) + "px";
      } else {
        trail.style.left = T.edgePad + "px";
        trail.style.width = Math.max(0, bx - T.edgePad) + "px";
      }
      ballEl.style.transform = "translateX(" + (bx - 8.5) + "px) translateY(" + (-Math.abs(S.wobble) * 0.28) + "px)";
      ballRot.setAttribute("transform", "rotate(" + (((bx / 6.4) * 57.29) % 360 + S.wobble) + ")");
      catEl.style.transform =
        "translateX(" + (S.catX - 30) + "px) translateY(" + S.bob + "px)" +
        " rotate(" + S.tilt + "deg) scaleX(" + (S.dir * (1 + S.wiggleX) * S.stretchX) + ")" +
        " scaleY(" + (S.squash * S.stretchY) + ")";
    }

    var rafId = null;
    function frame(now) {
      var dt = Math.min(0.05, (now - S.lastT) / 1000);
      S.lastT = now;
      S.scrollV = windowedV();
      if (now - S.lastScrollAt > 160) { S.scrollV = 0; samples.length = 0; }
      var max = scroller.scrollHeight - scroller.clientHeight;
      S.progress = max > 0 ? Math.max(0, Math.min(1, scroller.scrollTop / max)) : 0;
      think(now, dt); render(); toneCheck(now);
      var settled = S.reduced
        ? now - S.lastScrollAt > 200          /* calm mode: sleep between scrolls, wake() on scroll */
        : S.mode === "loaf" && Math.abs(S.catVX) < 2 && Math.abs(S.wobbleV) < 2;
      if (settled) { rafId = null; return; }
      rafId = window.requestAnimationFrame(frame);
    }
    function wake() {
      if (!rafId) { S.lastT = performance.now(); rafId = window.requestAnimationFrame(frame); }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    /* capture-phase document listener catches scrolls of ANY container
       (iOS body-scroller and similar modes never fire window scroll) */
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    window.addEventListener("resize", wake, { passive: true });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { if (rafId) window.cancelAnimationFrame(rafId); rafId = null; }
      else wake();
    });
    setPose("sit");
    wake();
  }

  function initPdpTabs() {
    document.querySelectorAll("[data-pdp-tabs]").forEach(function (box) {
      var tabs = box.querySelectorAll("[data-pdp-tab]");
      if (tabs.length < 2) return;
      function select(name) {
        tabs.forEach(function (t) {
          var on = t.getAttribute("data-pdp-tab") === name;
          t.setAttribute("aria-selected", on ? "true" : "false");
          t.tabIndex = on ? 0 : -1;
        });
        box.querySelectorAll("[data-pdp-panel]").forEach(function (p) {
          p.hidden = p.getAttribute("data-pdp-panel") !== name;
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener("click", function () { select(t.getAttribute("data-pdp-tab")); });
        t.addEventListener("keydown", function (e) {
          if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
          e.preventDefault();
          var arr = Array.prototype.slice.call(tabs);
          var i = arr.indexOf(t);
          var next = e.key === "ArrowRight" ? arr[(i + 1) % arr.length] : arr[(i - 1 + arr.length) % arr.length];
          next.focus();
          select(next.getAttribute("data-pdp-tab"));
        });
      });
    });
  }

  function init() {
    initReveal();
    initHeader();
    initAjaxCart();
    initSort();
    initGallery();
    initVariantSelect();
    initVariantTiles();
    initVariantOptions();
    initStickyAtc();
    initCartPage();
    initWelcomePopup();
    initScrollCat();
    initPdpTabs();
    refreshCartCount();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  // Re-init in the Shopify theme editor when sections reload
  document.addEventListener("shopify:section:load", init);
})();
